// Base
import Text from '@components/helpers/text/Text'
import { ChangeEvent, useState } from 'react'

// Styles
import styles from './Input.module.sass'

interface GenericProps {
  value: string
  onChange: Function
  required?: boolean
}

// Generic Input
interface InputProps extends GenericProps {
  name: string
  type: string
  label?: string
  placeholder?: string
  max?: string
  disabled?: boolean
  customClass?: string
  onToggle?: Function
  startIcon?: React.ReactNode
  endIcon?: React.ReactNode
  autoComplete?: string
  error?: string
}
const Input = ({
  name = 'name',
  type = 'text',
  placeholder,
  label,
  value,
  onChange,
  required,
  max,
  disabled = false,
  customClass = '',
  onToggle,
  startIcon,
  endIcon,
  autoComplete = 'on',
  error
}: InputProps) => {
  const [active, setActive] = useState(false)

  const toggle = (state: boolean) => {
    setActive(state)
    onToggle && onToggle(state)
  }

  return (
    <div className={`${styles.inputGroup} ${error ? styles['error'] : ''}`}>
      {error && (
        <Text tagName="p" variant="body-3" color="red" mobile>
          {error}
        </Text>
      )}
      {label && <label htmlFor={type}>{label}</label>}
      <div
        className={`${styles.inputGroup__inner} ${
          active ? styles['active'] : ''
        }`}
        onFocus={() => {
          toggle(true)
        }}
        onBlur={() => {
          toggle(false)
        }}
      >
        {startIcon && (
          <div className={styles.inputGroup__startIcon}>{startIcon}</div>
        )}
        <input
          className={`${styles.input} ${customClass}`}
          name={name}
          type={type}
          placeholder={placeholder}
          required={required}
          max={max}
          disabled={disabled}
          value={value}
          autoComplete={autoComplete}
          onChange={(e: ChangeEvent<HTMLInputElement>) =>
            onChange(e.target.value)
          }
        />
        {endIcon && <div className={styles.inputGroup__endIcon}>{endIcon}</div>}
      </div>
    </div>
  )
}

export default Input
